import React from "react";

import "../../../../styles/css/App.css";

import { Grid } from "@material-ui/core";
import InfiniteScroll from 'react-infinite-scroller';
import CircularProgress from '@mui/material/CircularProgress';
import { withRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMediaQuery } from 'react-responsive';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import TextField from '@mui/material/TextField';
import * as Constants from "../../../../consts/Constants.js";

import alerter from "../../../alerts/alerter";
import NoticeItem from "./notice-item"
import NoticeForm from "../admin/form";
import NoticeView from "./view";
import Pager from "../../../utils/pager";
import { Notice } from '../../../../plas/services/notices/models';

import service from '../../../../plas/services/notices/service';

function NoticesHistory({ history }) {
  
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const isMedium = useMediaQuery({ query: `(max-width: 900px)` });

  const pager = React.useRef(new Pager(5));
  const firstTime = React.useRef(false);

  const [items, setItems] = React.useState([]);
  const [moreItems, setMoreItems] = React.useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [selectedNotice, setSelectedNotice] = React.useState(null);
  const [searchTerm, setSearchTerm] = React.useState(null)

  React.useEffect(() => {
    let delayDebounceFn = null;
    if (firstTime.current) {
      delayDebounceFn = setTimeout(() => {
        resetSearch();
      }, 250)
    } else {
      firstTime.current = true
    }
    return () => {
      clearTimeout(delayDebounceFn)
    }
  }, [searchTerm])

  const edit = (notice) => {
    setSelectedNotice(new Notice({...notice}));
    setOpenDialog(true)
  }

  const create = () => {
    let notice = new Notice();
    setSelectedNotice(notice);
    setOpenDialog(true)
  }

  const open = (notice) => {
    setSelectedNotice(notice);
    setOpenDetails(true);
  }

  const cancel = () => {
    setOpenDialog(false);
  }

  const cancelDetails = () => {
    setOpenDetails(false);
  }

  const saved = () => {
    cancel()
    alerter.showSuccess("Se guardaron los cambios de la noticia.")
    resetSearch()
  }

  const getNextPage = () => {
    let page = pager.current.getNextPage();
    
    service.api.notices.getPage(page.startItem,page.endItem,searchTerm,0,"-creationTime",(response) => {
      if (response.result != null) {
        pager.current.update(response.result.data.length, response.result.total)
        setMoreItems(!pager.current.ended);
        setItems([...items, ...response.result.data])  
      } else {
        alerter.showError(response.error);
        setMoreItems(false);
      }
    });
  }

  const changeSearch = (e) => {
    let term = e.target.value.trim();
    if (!term)
      setSearchTerm(null);
    else
      setSearchTerm(term);
  }

  const resetSearch = () => {
    pager.current.reset();
    setItems([]);
    setMoreItems(true);
  }

  const ColoredLine = ({ color, marginTop, marginBottom }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          marginTop: marginTop !== undefined ? marginTop : 6,
          marginBottom: marginBottom !== undefined ? marginBottom : 16,
          height: 2
        }}
      />
  );

  return (
    <div>
      <Grid container>
        <Grid item xs={false} md={2} />
        <Grid item xs={12} md={8} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={true}>
                  <p style={{ fontSize: '28px', textAlign: 'left'}}>
                    Noticias
                  </p>
                </Grid>
                <Grid item>
                  { service.canAdmin() && (
                  <ThemeProvider theme={theme}>
                    <Button
                      startIcon={<AddRoundedIcon />}
                      variant="contained"
                      onClick={create}>
                      <b>Nueva noticia</b>
                    </Button>
                  </ThemeProvider>
                  )}
                </Grid>
              </Grid>
              <ColoredLine color="gray" marginTop={0} marginBottom={0} />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="Buscar" 
                    size="small" 
                    fullWidth 
                    variant="outlined" 
                    onChange={changeSearch}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div >
                <InfiniteScroll
                  pageStart={0}
                  loadMore={getNextPage}
                  hasMore={moreItems}
                  loader={<CircularProgress key={-1} size={32} style={{color:Constants.COLOR_PRIMARY, padding: 2}} color="inherit" />}>
                  {items.map((item, index) =>( 
                    <Grid key={item.id} container>
                      <Grid item xs={true}>
                        <NoticeItem key={index} notice={item} canEdit={false} onEdit={edit} onOpen={open} />
                      </Grid>
                    </Grid>
                  ))}
                </InfiniteScroll>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={false} md={2} />
      </Grid>

      <Dialog open={openDialog} fullWidth maxWidth="lg" fullScreen={isMedium}>
        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <NoticeForm fullWidth initialNotice={selectedNotice} onCancel={cancel} onSave={saved}/>
        </DialogContent>
      </Dialog>

      <Dialog open={openDetails} fullWidth maxWidth="lg" fullScreen={isMedium}>
        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <NoticeView fullWidth notice={selectedNotice} onClose={cancelDetails}/>
        </DialogContent>
      </Dialog>
    </div>
  );

}

export default withRouter(NoticesHistory);
